<template>
  <div>
    <div class="flex items-center space-x-4">
      <router-link :to="{ name: 'shippingTiersIndex' }" class="system-button">
        <arrow-icon class="w-4 fill-current rotate-90"></arrow-icon>
      </router-link>
      <h2>{{ isEditing ? "Editar" : "Crear" }} rango de envío</h2>
    </div>

    <div v-if="!loading" class="card mt-2">
      <form @submit.prevent="save">
        <div class="flex flex-col w-full">
          <label for="label">Etiqueta <span class="text-content-300 font-normal text-xs">(visible solo a admin)</span></label>
          <input id="label" type="text" v-model="form.label" placeholder="Ej. Caja chica" />
          <validation-errors :errors="errorFor('label')"></validation-errors>
        </div>

        <div class="flex flex-col sm:flex-row sm:space-x-4 mt-4">
          <div class="flex flex-col flex-1">
            <label for="min_grams">Peso mínimo (gramos)</label>
            <input id="min_grams" type="number" min="0" step="1" v-model.number="form.min_grams" />
            <validation-errors :errors="errorFor('min_grams')"></validation-errors>
          </div>
          <div class="flex flex-col flex-1">
            <label for="max_grams">Peso máximo (gramos)</label>
            <input id="max_grams" type="number" min="0" step="1" v-model.number="form.max_grams" placeholder="(vacío = sin límite)" />
            <validation-errors :errors="errorFor('max_grams')"></validation-errors>
          </div>
        </div>

        <div class="flex flex-col w-full mt-4">
          <label for="price">Precio de envío (MXN)</label>
          <input id="price" type="number" min="0" step="0.01" v-model.number="form.price" />
          <validation-errors :errors="errorFor('price')"></validation-errors>
        </div>

        <div class="flex flex-col sm:flex-row sm:space-x-4 mt-4">
          <div class="flex flex-col flex-1">
            <label for="position">Orden</label>
            <input id="position" type="number" min="0" v-model.number="form.position" />
          </div>
          <div class="flex items-center mt-6 sm:mt-0">
            <label class="inline-flex items-center cursor-pointer">
              <input type="checkbox" v-model="form.is_active" class="mr-2" />
              <span>Activo</span>
            </label>
          </div>
        </div>

        <primary-button type="submit" class="mt-6 mx-0" :loading="loadingForm">
          {{ isEditing ? "Guardar" : "Crear" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Shipping Tier Form",
  data() {
    return {
      form: { label: "", min_grams: 0, max_grams: null, price: 100, is_active: true, position: 0 },
      loading: false,
      loadingForm: false,
      isEditing: false,
    };
  },
  mixins: [validationErrors],
  created() {
    this.$store.commit("setStoreSelectedTab", "shippingTiers");
    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadTier();
    }
  },
  methods: {
    async loadTier() {
      this.loading = true;
      try {
        const response = await api.shippingWeightTiers.getById(this.$route.params.id);
        this.form = {
          label: response.label ?? "",
          min_grams: Number(response.min_grams ?? 0),
          max_grams: response.max_grams === null ? null : Number(response.max_grams),
          price: Number(response.price ?? 0),
          is_active: !!response.is_active,
          position: Number(response.position ?? 0),
        };
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }
      this.loading = false;
    },
    save() {
      if (!this.validateForm()) {
        this.$store.dispatch("errorSnack", "Favor de llenar todos los campos correctamente.");
        return;
      }
      this.isEditing ? this.updateTier() : this.createTier();
    },
    validateForm() {
      this.errors = {};
      if (this.form.min_grams === null || this.form.min_grams === "" || this.form.min_grams < 0) {
        this.errors["min_grams"] = ["Requerido (≥ 0)."];
      }
      if (this.form.max_grams !== null && this.form.max_grams !== "" && this.form.max_grams <= this.form.min_grams) {
        this.errors["max_grams"] = ["Debe ser mayor al peso mínimo."];
      }
      if (this.form.price === null || this.form.price === "" || this.form.price < 0) {
        this.errors["price"] = ["Requerido (≥ 0)."];
      }
      return Object.keys(this.errors).length === 0;
    },
    payload() {
      return {
        label: this.form.label || null,
        min_grams: Number(this.form.min_grams),
        max_grams: this.form.max_grams === null || this.form.max_grams === "" ? null : Number(this.form.max_grams),
        price: Number(this.form.price),
        is_active: !!this.form.is_active,
        position: Number(this.form.position) || 0,
      };
    },
    async createTier() {
      this.loadingForm = true;
      try {
        const response = await api.shippingWeightTiers.create(this.payload());
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "shippingTiersIndex" });
      } catch (error) {
        if (is422(error)) this.errors = error.response?.data?.errors ?? {};
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }
      this.loadingForm = false;
    },
    async updateTier() {
      this.loadingForm = true;
      try {
        const response = await api.shippingWeightTiers.update(this.$route.params.id, this.payload());
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "shippingTiersIndex" });
      } catch (error) {
        if (is422(error)) this.errors = error.response?.data?.errors ?? {};
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }
      this.loadingForm = false;
    },
  },
};
</script>
